import { RAN_DB_UPDATE_SITE } from '../../../common/constants/constants';
import apiClient from '../../../common/functions/api_axios_instance.function';
import { handleApiError } from '../../../common/functions/errorHandler.function';

export const updateFiberSite = async (id, data) => {
  try {
    const response = await apiClient.put(RAN_DB_UPDATE_SITE(id), data, {});
    return response.data;
  } catch (error) {
    handleApiError(error);
  }
};
